<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <h3 class="title">民航基础数据平台</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码" @keyup.enter.native="handleLogin">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 67%" @keyup.enter.native="handleLogin">
          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
        </el-input>
        <el-button size="medium" @click="useVerify">获取验证码</el-button>
        <Verify @success="success" :captcha-type="'blockPuzzle'" :img-size="{ width: '330px', height: '155px' }" ref="verify"> </Verify>
        <!-- <div class="login-code"> :mode="pop"
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div> -->
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="radioLanguage" @change="changeHander">
          <el-radio label="zh_cn">中文</el-radio>
          <el-radio label="en_us">英文</el-radio>
        </el-radio-group>
        <!-- <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 0px 50px;">记住密码</el-checkbox> -->
      </el-form-item>
      <!-- <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <el-button :loading="false" size="medium" type="primary" style="width:45%;" @click.native.prevent="handleRegister">
          <span v-if="true">注 册</span>
          <span v-else>注 册 中...</span>
        </el-button>
        <el-button :loading="loading" size="medium" type="primary" style="width:45%;margin-right:20px" @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <span style="color: red;">禁止上传涉密文件</span>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <p>
        lit民航基础数据平台V1.0 联系电话: 010-84663936<br />
        版权所有©中国民用航空局清算中心 京ICP备07001632号
      </p>
    </div>
    <el-dialog
      v-dialogDrag
      title="用户注册 -> 资料填写 -> 完成注册"
      :visible.sync="registerDialog.visible"
      :before-close="beforeClose"
      :close-on-click-modal="false"
      width="500px"
      style="height:1100px;"
    >
      <el-form :model="registerForm" size="mini" ref="ruleform" :rules="registerRules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台用户申请单" style="margin-right:20px">
              <br />
              <el-tag>
                <i class="el-icon-download" />
                <a style="text-align:right" href="/registertemplate.docx" target="_blank" download="平台用户申请单.docx">点击下载模版</a>
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="upload" label="上传word/upload*:">
              <el-upload
                ref="upload"
                action="#"
                :show-file-list="true"
                :on-remove="removeFile"
                :file-list="fileList"
                :on-change="handleChange"
                :auto-upload="false"
                :limit="1"
                :on-exceed="handleExceed"
                accept=".docx,.doc"
                drag
                multiple
              >
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="name" label="姓名/Name*:" style="margin-right:20px">
              <el-input v-model="registerForm.name" type="text"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="gender" label="性别/Gender*:">
              <el-select v-model="registerForm.gender" placeholder="请选择" style="width: auto" size="mini">
                <el-option v-for="item in registerDialog.genders" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="email" label="邮箱/Email*:" style="margin-right:20px">
              <el-input v-model="registerForm.email" type="text"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="mobile" label="手机/Mobile phone*:">
              <el-input v-model="registerForm.mobile" type="text"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="telephone" label="电话/Telephone*:" style="margin-right:20px">
              <el-input v-model="registerForm.telephone" type="text"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="position" label="职位/Position:">
              <el-input v-model="registerForm.position" type="text"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="callname" label="称呼/Call:" style="margin-right:20px">
              <el-input v-model="registerForm.callname" type="text"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="postcode" label="邮编/Zip-code:">
              <el-input v-model="registerForm.postcode" type="text"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="departmentId" label="所属部门/Department*:" style="margin-right:20px">
              <el-select v-model="registerForm.departmentId" placeholder="请选择" style="width: auto" size="mini" filterable>
                <el-option v-for="item in registerDialog.departmentIds" :key="item.sequence" :label="item.name" :value="item.sequence"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="businesstype" label="业务类型/Service type:">
              <el-select v-model="registerForm.businesstype" placeholder="请选择" size="mini" style="width:180px">
                <el-option v-for="item in registerDialog.businesstypes" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="dataType" label="数据类型:">
              <el-select v-model="registerForm.dataType" placeholder="请选择" style="width: auto" size="mini">
                <el-option v-for="item in registerDialog.dataTypes" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="address" label="地址/address:"><el-input v-model="registerForm.address" type="text"> </el-input> </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="iscontact">
            <el-checkbox label="是否为业务账单联系人" v-model="registerForm.iscontact" />
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="registerSubmit">注 册(Register)</el-button>
        <el-button size="mini" @click="beforeClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
//import axios from "axios";
// import mock from "@/mock/index.js";, decrypt, getck
import { getCodeImg, getVerificateCode } from "@/api/system/login.js";
//import { setToken } from "@/utils/auth.js";
//import { getCodeImg } from "@/http/modules/system/login.js";
import { encrypt, decrypt } from "@/utils/jsencrypt";
//import variable from "@/assets/scss/variable.scss";
import { i18nResult } from "@/utils/commonUtils";
import Verify from "@/components/verifition/Verify";
import "@/utils/directives.js"; //弹窗拖拽
import request from "@/utils/request";
// import { getThirdPartyToken, getToken } from "../../utils/auth";
// import { isEmptyStr } from "../../utils/commonUtils";
export default {
  name: "Login",
  components: {
    Verify
  },
  data() {
    return {
      fileList: [],
      radioLanguage: "zh_cn",
      codeUrl: "",
      loading: false,
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        src: ""
      },
      // loginForm: {
      //   username: "LIZX",
      //   password: "ABDP",
      //   rememberMe: false,
      //   code: "123",
      //   src: ""
      // },
      loginRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      registerRules: {
        name: [{ required: true, message: "姓名/Name不能为空", trigger: "blur" }],
        gender: [{ required: true, message: "性别/Gender不能为空", trigger: "blur" }],
        email: [{ required: true, message: "邮箱/Email不能为空", trigger: "blur" }],
        mobile: [{ required: true, message: "手机/Mobile phone不能为空", trigger: "blur" }],
        telephone: [{ required: true, message: "电话/Telephone不能为空", trigger: "blur" }],
        departmentId: [{ required: true, message: "所属部门/Department不能为空", trigger: "blur" }]
      },
      checked: true,
      registerDialog: {
        visible: false,
        genders: [
          { value: "M", label: "男" },
          { value: "F", label: "女" }
        ],
        dataTypes: ["AIRLINE", "AIRPORT", "ATC"],
        departmentIds: [],
        businesstypes: ["select all", "空管业务", "机场服务费", "民航发展基金（旅客）", "民航发展基金（公司）"]
      },
      registerForm: {}
    };
  },
  methods: {
    // 选择文件时，往fileList里添加
    handleChange(fileList) {
      this.fileList.push(fileList);
    },
    // 移除文件
    removeFile(file) {
      // 移除文件时，要重新给fileList赋值
      const arr = [];
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].uid !== file.uid) {
          arr.push(this.fileList[i]);
        }
      }
      this.fileList = arr;
    },
    // 上传文件超出个数
    handleExceed() {
      this.$message.warning("文件个数超出限制");
    },
    getCode() {
      getCodeImg().then(res => {
        // debugger;
        console.log("data:image/gif;base64," + res.data[0].img);
        this.codeUrl = "data:image/gif;base64," + res.data[0].img;
        this.loginForm.uuid = res.data[0].uuid;
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          //保存用户信息到cookies
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set("rememberMe", this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          //this.$router.push({ path: this.redirect || "/" });
          this.$store
            .dispatch("Login", this.loginForm)
            .then(res => {
              //debugger;
              if (res != null) {
                // getck().then(response => {
                //   console.log(response.data);
                // });
                this.$router.push({ path: this.redirect || "/" });
                let locale = localStorage.getItem("locale") || "zh_cn";
                i18nResult(locale).then(response => {
                  if (response) {
                    switch (localStorage.getItem("locale")) {
                      case "zh_cn":
                        this.$i18n.setLocaleMessage("zh_cn", response.data[0]);
                        break;
                      default:
                        this.$i18n.setLocaleMessage("en_us", response.data[0]);
                    }
                  }
                });
              } else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
              this.getCode();
            });
        }
      });
    },
    handleRegister() {
      this.registerDialog.visible = true;
      this.getDepartmentCode();
    },
    getDepartmentCode() {
      request({
        url: "/system/sysdepartment/queryDept",
        method: "post",
        params: { pageNum: 1, pageSize: 0 }
      }).then(rep => {
        if (rep && rep.data.length > 0) {
          this.registerDialog.departmentIds = rep.data;
        }
      });
    },
    registerSubmit: function() {
      //校验输入框信息
      this.$refs["ruleform"].validate(valid => {
        if (valid) {
          //判断文件是否存在
          if (this.fileList.length === 0) {
            this.$message.warning("请选取文件");
            return;
          }
          //设置传入参数
          const formData = new FormData();
          formData.append("file", this.fileList[0].raw);
          formData.append("filePath", "registerUpload/" + this.registerForm.name);
          //上传文件
          request({
            url: "/system/fileManage/registerUpload",
            method: "post",
            data: formData
          }).then(rep => {
            if (rep && rep.data.length > 0 && rep.code == 200) {
              var filePath = rep.data[0].filePath;
              if (filePath != "") {
                //文件上传路径
                this.registerForm.uploadPath = filePath;
                //用户注册
                this.registerForm.iscontact == true ? (this.registerForm.iscontact = "Y") : "N";
                if (this.registerForm.businesstype == "select all") {
                  this.registerForm.businesstype = this.registerDialog.businesstypes.slice(1, 5).join(",");
                }
                request.post("/system/autSysUser/insertAutSysUser", this.registerForm, {}).then(rep => {
                  if (rep && rep.code == 200) {
                    this.registerDialog.visible = false;
                    this.ShowMessage("注册成功,请联系管理员审核", "success", null);
                  }
                });
              }
            }
          });
        }
      });
    },
    beforeClose() {
      this.registerDialog.visible = false;
    },
    refreshCaptcha: function() {
      //this.loginForm.src = this.global.baseUrl + "/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields();
    },
    changeHander(val) {
      if (val == "zh_cn") {
        localStorage.setItem("locale", "zh_cn");
        this.$i18n.locale = localStorage.getItem("locale");
      } else if (val == "en_us") {
        localStorage.setItem("locale", "en_us");
        this.$i18n.locale = localStorage.getItem("locale");
      }
    },
    useVerify() {
      this.$refs.verify.show();
    },
    success() {
      //debugger;
      if (this.loginForm.username && this.loginForm.password) {
        getVerificateCode({ username: this.loginForm.username, password: this.loginForm.password }).then(() => {
          this.ShowMessage("发送验证码成功", "success");
        });
      } else {
        this.ShowMessage("请填写账号密码", "error");
      }
    }
  },

  created() {
    //this.getCode();
    // this.getSSOToken();
    this.getCookie();
  },

  mounted() {
    //this.refreshCaptcha();
    localStorage.getItem("locale") == "en_us" ? (this.radioLanguage = "en_us") : (this.radioLanguage = "zh_cn");
    if (localStorage.getItem("locale") == null) {
      localStorage.setItem("locale", "zh_cn");
      this.$i18n.locale = localStorage.getItem("locale");
    }
  }
};
</script>

<style lang="scss">
.el-upload-dragger {
  width: 230px;
  height: 28px;
}
</style>
<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../../assets/images/login-background.png");
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
  font-size: 28;
  font-family: 宋体;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 25px;
    width: 14px;
    margin-left: 2px;
    margin-top: 8px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.login-code-img {
  height: 38px;
}
.el-login-footer {
  height: 40px;
  //line-height: 40px;
  position: fixed;
  bottom: 15px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
